<!--美育浸润首页-->
<template>
    <div class="my-studio_nav_content">
        <div class="my-content-container" v-show="showMode==='page'">
            <div class="item-container">
                <div class="item-child-container">
                    <div class="my-item-one" v-for="item in itemList.slice(0,4)" :key="item" @click="pageMyjr(item)">
                        <div class="item-one-child">
                            <div class="item-month">{{item.itemMonth}}</div>
                            <div class="item-name">{{item.itemName}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-container mt-x">
                <div class="item-child-container">
                    <div class="my-item-one" v-for="item in itemList.slice(4,8)" :key="item" @click="pageMyjr(item)">
                        <div class="item-one-child">
                            <div class="item-month">{{item.itemMonth}}</div>
                            <div class="item-name">{{item.itemName}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-container mt-x">
                <div class="item-child-container">
                    <div class="my-item-one" v-for="item in itemList.slice(8,12)" :key="item" @click="pageMyjr(item)">
                        <div class="item-one-child">
                            <div class="item-month">{{item.itemMonth}}</div>
                            <div class="item-name">{{item.itemName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" v-show="showMode==='detail'">
            <myjr-page :item-id="itemId" :item-name="itemName" :mark-info="markInfo"
                        @change-mode="changeModel" />
        </div>
    </div>
</template>
<script>
import {listItem} from "@/api/admin/item"
import myjrPage from "@/components/myjr/myjrPage.vue";

export default {
    name:'homeMyjr',
    components:{myjrPage},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        courseMode(newValue,oldValue){
            this.showMode = newValue;
        },
    },
    mounted() {
    },
    created() {
        this.queryItemList();
    },
    data() {
        return {
            showMode:'page',
            itemList:[],
            itemId:'',
            itemName:'',
            markInfo:'pageSub',
        }
    },
    methods: {
        queryItemList(){
            listItem({ itemType: 1 }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode);
        },
        pageMyjr(item){
            this.itemId = item.itemId;
            this.itemName = item.itemName;
            this.markInfo = this.markInfo+new Date();
            this.showMode = 'detail';
            this.$emit('change-mode',this.showMode);
        },
    }
}
</script>
<style>
.my-studio_nav_content{
    width: 100%;
    background-color: #fff;
    height: calc(100vh - 90px);

}
.my-content-container{
    width: 100%;
    height: 100%;
    padding: 50px 20px 50px 20px;
    box-sizing: border-box;
}
.item-container{
    width: 100%;
    height: calc(33% - 50px);

}
.mt-x{
    margin-top: 75px;
}
.item-child-container{
    width: 100%;
    height: 100%;
    display: flex;
}
.my-item-one{
    width: calc(25% - 30px);
    height: 100%;
    background-color: #0d55a4;
    border-radius: 4px;
    cursor: pointer;
    color: #fff;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    margin-left: 20px;
    margin-right: 20px;
    font-weight: bold;
    font-family: sans-serif;
    font-size: 15px;
}
.my-item-one:hover{
    background-color: #fff!important;
    color: #0d55a4!important;
    border: 1px solid #0d55a4!important;
    box-sizing: border-box;
}
.item-one-child{
    width: 100%;
    height: 50px;
}
.item-month{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
}
.item-name{
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
}
</style>